<p>base-widget works!</p>
<app-sb-messages [messages]="msgs"></app-sb-messages>
